'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgTruck } from '@common/icon';
import { Fragment, useRef } from 'react';
import { useDynamicSize } from '@/hooks/useDynamicSize';
interface NoticeProps {
  title: string;
  productName?: string;
  content: string;
}
export const Notice = t0 => {
  const $ = _c(67);
  const {
    productName,
    content,
    title
  } = t0;
  const ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      baseWidth: 375,
      ref
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    dynamicSize
  } = useDynamicSize(t1);
  const parseNoticeText = _temp2;
  let t2;
  if ($[1] !== dynamicSize) {
    t2 = dynamicSize(36);
    $[1] = dynamicSize;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== dynamicSize) {
    t3 = dynamicSize(36);
    $[3] = dynamicSize;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== dynamicSize) {
    t4 = dynamicSize(44);
    $[5] = dynamicSize;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== dynamicSize) {
    t5 = dynamicSize(44);
    $[7] = dynamicSize;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = {
      paddingLeft: t2,
      paddingRight: t3,
      paddingTop: t4,
      paddingBottom: t5
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== dynamicSize) {
    t7 = dynamicSize(6);
    $[14] = dynamicSize;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== dynamicSize) {
    t8 = dynamicSize(8);
    $[16] = dynamicSize;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      gap: t7,
      marginBottom: t8
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== dynamicSize) {
    t10 = dynamicSize(40);
    $[21] = dynamicSize;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== dynamicSize) {
    t11 = dynamicSize(40);
    $[23] = dynamicSize;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = {
      width: t10,
      height: t11
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== dynamicSize) {
    t13 = dynamicSize(24);
    $[28] = dynamicSize;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== dynamicSize) {
    t14 = dynamicSize(24);
    $[30] = dynamicSize;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <SvgTruck className="text-Gray-black" style={{
      width: t13,
      height: t14
    }} />;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t12 || $[36] !== t15) {
    t16 = <div className="shrink-0 rounded-pill bg-O-500 flex-center" style={t12}>{t15}</div>;
    $[35] = t12;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== dynamicSize) {
    t17 = dynamicSize(16);
    $[38] = dynamicSize;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17) {
    t18 = {
      fontSize: t17
    };
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t18 || $[43] !== title) {
    t19 = <span className="font-700 text-O-500 typo-body3" style={t18}>{title}</span>;
    $[42] = t18;
    $[43] = title;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t16 || $[46] !== t19 || $[47] !== t9) {
    t20 = <div className="flex items-center" style={t9}>{t16}{t19}</div>;
    $[45] = t16;
    $[46] = t19;
    $[47] = t9;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== dynamicSize || $[50] !== productName) {
    t21 = productName ? <p className="font-700 text-O-500 typo-body3" style={{
      fontSize: dynamicSize(16)
    }}>{productName}</p> : null;
    $[49] = dynamicSize;
    $[50] = productName;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="my-20 w-full border-t-1 border-Gray-800" />;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== dynamicSize) {
    t23 = dynamicSize(22);
    $[53] = dynamicSize;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t23) {
    t24 = {
      fontSize: t23
    };
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== content) {
    t25 = parseNoticeText(content);
    $[57] = content;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t24 || $[60] !== t25) {
    t26 = <p className="whitespace-pre-line font-700 text-Gray-white typo-h6" style={t24}>{t25}</p>;
    $[59] = t24;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t20 || $[63] !== t21 || $[64] !== t26 || $[65] !== t6) {
    t27 = <article className="bg-Gray-black" ref={ref} style={t6}>{t20}{t21}{t22}{t26}</article>;
    $[62] = t20;
    $[63] = t21;
    $[64] = t26;
    $[65] = t6;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  return t27;
};
function _temp(part, index) {
  if (part.startsWith("**") && part.endsWith("**")) {
    const boldText = part.slice(2, -2);
    return <strong key={index} className="font-700 text-O-500">{boldText}</strong>;
  }
  return <Fragment key={index}>{part}</Fragment>;
}
function _temp2(text) {
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map(_temp);
}